module.exports = __webpack_public_path__ + "static/media/entregando_motorizado.2163bee7.gif";